(function() {
  const swiper_Sections = document.querySelectorAll('[data-swiper_id^="swiper__controls_"]');
     
  if (swiper_Sections) {
    
      function convertBooleanToNumber(value) {
        return value === "true" ? 1 : 0;
      }

    swiper_Sections.forEach(swiper_Section => {
      const swiperId = swiper_Section.dataset.swiper_id;
      const navigation = convertBooleanToNumber(swiper_Section.dataset.navigation ?? "false");
      const autoplay = convertBooleanToNumber(swiper_Section.dataset.autoplay ?? "false");
      const slide_count = parseFloat(swiper_Section.dataset.slide_count ?? "3");
      const slide_count_tab = parseFloat(swiper_Section.dataset.slide_count_tab ?? "2");
      const slide_count_mobile = parseFloat(swiper_Section.dataset.slide_count_mobile ?? "1");
      const centeredSlides = convertBooleanToNumber(swiper_Section.dataset.centeredslides ?? "false");
      const loop = convertBooleanToNumber(swiper_Section.dataset.loop ?? "false");
      const speed = parseInt(swiper_Section.dataset.speed ?? "3000");
      const speed_mobile = parseInt(swiper_Section.dataset.speed_mobile ?? "2000");
      const speed_tab = parseInt(swiper_Section.dataset.speed_tab ?? "2500");
      const spaceBetween = parseInt(swiper_Section.dataset.spacebetween ?? "30");
      const spaceBetween_mobile = parseInt(swiper_Section.dataset.spacebetween_mobile ?? "15");
      const pagination = convertBooleanToNumber(swiper_Section.dataset.pagination ?? "false");
      const autoHeight = convertBooleanToNumber(swiper_Section.dataset.autoheight ?? "true");
      const paginationType = swiper_Section.dataset.pagination_type ?? "bullets";
      const freeMode = swiper_Section.dataset.freemode === "true" ?? false;
      const effect = swiper_Section.dataset.effect ?? "slide";
      const rows = parseInt(swiper_Section.dataset.rows ?? "1");
      const rows_mobile = parseInt(swiper_Section.dataset.rows_mobile ?? "1");
      const allowTouchMove = convertBooleanToNumber(swiper_Section.dataset.allowtouchmove ?? "true");
      
      //thumbnails navigation
      const swiperThumbnailContainer = swiper_Section.querySelector(`.swiper__Container`);
      let swiper;

      if (swiperThumbnailContainer) {
        swiper = new Swiper(`[data-swiper_id="${swiperId}"] .swiper__Container`, {
          spaceBetween: 10,
          direction: "horizontal",
          slidesPerView: 2.5,
          freeMode: true,
          watchSlidesProgress: true,
          breakpoints: {
            768: {
              spaceBetween: 5,
              slidesPerView: 4.5,
              direction: "vertical",
            },
          },
        });
      }

      //main image
      const swiper2 = new Swiper(`[data-swiper_id="${swiperId}"] .swiper__Container2`, {
        spaceBetween: 10,
        freeMode: freeMode,
        observer: true,
        observeParents: true,
        autoHeight: autoHeight,
        loop: loop,
        effect: effect,
        grabCursor: true,
        loopAddBlankSlides: true,
        spaceBetween: spaceBetween_mobile,
        preventClicks: true,
        preventClicksPropagation: true,
        thumbs: {
          swiper: swiper,
        },
         pagination: {
          el: `[data-swiper_id="${swiperId}"] .swiper-pagination`,
          clickable: true,
        },
        scrollbar: {
          el: `[data-swiper_id="${swiperId}"] .swiper-scrollbar`,
        },
        keyboard: { enabled: true },
        navigation: {
          nextEl: `[data-swiper_id="${swiperId}"] .swiper-button-next`,
          prevEl: `[data-swiper_id="${swiperId}"] .swiper-button-prev`,
        },
        initialSlide: 0,
        autoplay: { enabled: autoplay, delay: speed },
        slidesPerView: slide_count_mobile,
        grid: {
          rows: rows_mobile,
        },
        centeredSlides: false,
        centeredSlidesBounds: false,
        slidesPerGroupSkip: 1,
        breakpoints: {
          768: {
            slidesPerView: slide_count_tab,
            centeredSlides: false,
            spaceBetween: spaceBetween_mobile,
            slidesPerGroupSkip: 1
          },
          1024: {
            slidesPerView: slide_count,
            centeredSlides: false,
            spaceBetween: spaceBetween,
            slidesPerGroupSkip: 1
          },
        },
      });

    });
  }
})();

